import React, { useEffect, useState } from "react";
import { Form, Input, Button, Image, Divider, Spin, Select } from "antd";
import logoBlue from "../../img/tillit_logo_blue.svg";
import LoginMicrosoft from "./LoginMicrosoft";
import { MailOutlined, LockOutlined } from "@ant-design/icons";
import AuthService from "../../services/auth/AuthService";
import { useDispatch, useSelector } from "react-redux";
import {
  setLanguage,
  setProfile,
  setUserPermissions,
} from "../../redux/actions";
import styles from "./Login.module.css";
import hrFlag from "../../img/languages/hr.svg";
import usFlag from "../../img/languages/us.svg";
import nlFlag from "../../img/languages/nl.svg";
import frFlag from "../../img/languages/fr.svg";
import NotificationsUtil from "../shared/utils/NotificationsUtil";
import { NOTIFICATION_TYPES } from "../../config/constants";
import { LANGUAGE_CROATIAN, LANGUAGE_DUTCH, LANGUAGE_ENGLISH, LANGUAGE_FRENCH } from "../../config/consts/languages";

const Login = () => {
  const { language } = useSelector((state: any) => ({
    language: state.language,
  }));

  const [loginForm] = Form.useForm();
  const { Option } = Select;

  const dispatch = useDispatch();
  const [inputEmail, setInputEmail] = useState("");
  const [inputPassword, setInputPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleMicrosoftLogin = (data) => {
    setIsLoading(data);
  };

  const onEmailInputChange: React.ChangeEventHandler<HTMLInputElement> = (
    event
  ) => {
    const inputValue = event.target.value;
    setInputEmail(inputValue);
  };

  const onPasswordInputChange: React.ChangeEventHandler<HTMLInputElement> = (
    event
  ) => {
    const inputValue = event.target.value;
    setInputPassword(inputValue);
  };

  const handleSignIn = () => {
    const model = {
      username: inputEmail,
      password: inputPassword,
    };
    setIsLoading(true);
    AuthService.login(model)
      .then((response: any) => {
        if (!response.data) {
          NotificationsUtil.openNotificationDialog({
            message: "Failed to login",
            description: "Invalid username or password",
            placement: "bottomRight",
            type: NOTIFICATION_TYPES.ERROR,
            logError: false,
          });
          setIsLoading(false);
        } else {
          const profile = {
            id: response.data.id,
            displayName: response.data.displayName,
            email: response.data.email,
            accessToken: response.data.accessToken,
            isSocial: response.data.isSocial,
          };
          dispatch(setProfile(profile));
          dispatch(setUserPermissions(response.data.permissions));
        }
        setIsLoading(false);
      })
      .catch((error: any) => {
        NotificationsUtil.openNotificationDialog({
          message: "Failed to login",
          description: error.response.data,
          placement: "bottomRight",
          type: NOTIFICATION_TYPES.ERROR,
          logError: false,
        });
        setIsLoading(false);
      });
  };

  const onClickLanguageChange = (language: string) => {
    dispatch(setLanguage(language));
  };

  useEffect(() => {
    if (language) {
      loginForm.setFieldsValue({ chooseLanguage: language });
    } else {
      loginForm.setFieldsValue({ chooseLanguage: LANGUAGE_ENGLISH });
    }
  }, [language]);

  return (
    <div style={{ backgroundColor: `var(--background)`, height: "100vh" }}>
      <div className={styles.login_wrap}>
        <Image
          style={{ width: "100px" }}
          className={styles.login_logo}
          preview={false}
          src={logoBlue}
        />
        <div className={styles.welcome_msg}>
          <span>Welcome back</span>
        </div>
        <div>
          <LoginMicrosoft isLoginInProgress={handleMicrosoftLogin} />
        </div>
        <Divider style={{ margin: 0 }} plain>
          or
        </Divider>
        <Form
          layout="vertical"
          name="normal_login"
          form={loginForm}
          className={styles.login_form}
          initialValues={{ remember: true }}
        >
          <Form.Item
            style={{ marginBottom: "15px" }}
            label="Email"
            name="Email"
            rules={[{ required: true, message: "Please input your email!" }]}
          >
            <Input
              prefix={
                <MailOutlined
                  style={{ color: "var(--dark-grey)" }}
                  className={styles.site_form_item_icon}
                />
              }
              placeholder="Email"
              value={inputEmail}
              onInput={onEmailInputChange}
            />
          </Form.Item>
          <Form.Item
            style={{ marginBottom: "15px" }}
            label="Password"
            name="password"
            rules={[{ required: true, message: "Please input your password!" }]}
          >
            <Input
              prefix={
                <LockOutlined
                  style={{ color: "var(--dark-grey)" }}
                  className={styles.site_form_item_icon}
                />
              }
              type="password"
              placeholder="Password"
              value={inputPassword}
              onInput={onPasswordInputChange}
            />
          </Form.Item>
          <Form.Item style={{ textAlign: "end", marginBottom: "15px" }}>
            <a className={styles.login_form_forgot} href="">
              Forgot password?
            </a>
          </Form.Item>

          <Form.Item label="Choose language" name="chooseLanguage">
            <Select onChange={onClickLanguageChange} value={language}>
              <Option value={LANGUAGE_ENGLISH}>
                English
                <Image
                  src={usFlag}
                  className={styles.dropdown_flag}
                  preview={false}
                ></Image>
              </Option>
              <Option value={LANGUAGE_DUTCH}>
                Dutch
                <Image
                  src={nlFlag}
                  className={styles.dropdown_flag}
                  preview={false}
                ></Image>
              </Option>
              <Option value={LANGUAGE_FRENCH}>
                French
                <Image
                  src={frFlag}
                  className={styles.dropdown_flag}
                  preview={false}
                ></Image>
              </Option>
              <Option value={LANGUAGE_CROATIAN}>
                Croatian
                <Image
                  src={hrFlag}
                  className={styles.dropdown_flag}
                  preview={false}
                ></Image>
              </Option>
            </Select>
          </Form.Item>

          <Form.Item style={{ marginBottom: "15px" }}>
            {!isLoading && (
              <Button
                shape="default"
                block
                type="primary"
                htmlType="submit"
                className={styles.login_form_button}
                onClick={handleSignIn}
              >
                Sign in
              </Button>
            )}
            {isLoading && (
              <div className={styles.spinner}>
                <Spin size="large" />
              </div>
            )}
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default Login;
